import './Schedule.css';
import axios from 'axios';

export const updateSPxp = async (
  idGame,
  odds,
  idLinetype,
  newValue, // linea
  idSport,
  teamNumber,
  play,
  column,
  chgLine,
  chgOdds,
  otherTeam,
  IdGameType,
  otherColumn,
  otherPlay,
  isOdd, // 1  is just the spread, 2 is spread odd
  valueHasChanged,
  setRecentUpdatedGame,
  setValueHasChanged,
  props,
) => {
  if (!valueHasChanged) {
    return;
  }
  props.setIsLoading(true);
  setRecentUpdatedGame(idGame);
  props.setLastChangedGamedID(idGame);
  console.log('props===>', props);
  try {
    // Crear el objeto request
    const moveSpreadRequest = {
      IdLineType: idLinetype,
      IdGameType: IdGameType,
      IdSport: idSport,
      Line: idSport !== "MLB" ? 1 : 3,
      Value: Math.abs(newValue),
      ChgLine: chgLine,
      ChgOdds: chgOdds,
      IdGame: idGame,
      NewValue: newValue == null ? null : parseFloat(newValue),
      Odds: parseInt(odds),
      Play: play,
      OtherPlay: otherPlay,
      IsOdd: isOdd,
      IdUser: props.userId, // Asegúrate de que tienes el IdUser disponible en props
      TeamNumber: teamNumber,
      OtherTeam: otherTeam,
      Column: column,
      OtherColumn: otherColumn,
    };
    console.log("MoveSpread request:", moveSpreadRequest);
    // Llamar al backend
    const url = `${process.env.REACT_APP_API2_URL}/Wager/MoveSpread`;
    const response = await axios.post(url, moveSpreadRequest);

    // Manejar la respuesta
    if (response.status === 200) {
      props.setIsLoading(false);
      props.searchGameValues();
      setValueHasChanged(true);
    } else {
      props.setIsLoading(false);
      console.error("Error updating spread:", response);
    }
  } catch (error) {
    props.setIsLoading(false);
    console.error("Error updating spread:", error);
  }
};
